import { SwitchRow } from '@components'

import { Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { useFormContext } from '../../../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../../../types/invoiceSettingsFormSchema'

export const ApplyColorToDocumentElements = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const { FormItem } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <>
      <Text colorVariant="placeholder">{t('settings.organization.external_invoice.appearance.apply_color.title')}</Text>
      <FormItem
        name="shouldApplyTemplateColorToDividers"
        render={({ field: { onChange, value, ...props } }) => (
          <SwitchRow
            {...props}
            checked={value}
            label={t('settings.organization.external_invoice.appearance.apply_color.switch_label.dividers')}
            onChange={(event) => {
              onChange(event)
              trackInvoicingSettings('Color applied to Table lines', { checked: event.target.checked })
            }}
          />
        )}
      />
      <FormItem
        name="shouldApplyTemplateColorToTotal"
        render={({ field: { onChange, value, ...props } }) => (
          <SwitchRow
            {...props}
            checked={value}
            label={t('settings.organization.external_invoice.appearance.apply_color.switch_label.total')}
            onChange={(event) => {
              onChange(event)
              trackInvoicingSettings('Color applied to Total due', { checked: event.target.checked })
            }}
          />
        )}
      />
      <FormItem
        name="shouldApplyTemplateColorToColumnHeaders"
        render={({ field: { onChange, value, ...props } }) => (
          <SwitchRow
            {...props}
            checked={value}
            label={t('settings.organization.external_invoice.appearance.apply_color.switch_label.column_headers')}
            onChange={(event) => {
              onChange(event)
              trackInvoicingSettings('Color applied to Column headers', { checked: event.target.checked })
            }}
          />
        )}
      />
      <FormItem
        name="shouldApplyTemplateColorToHeader"
        render={({ field: { onChange, value, ...props } }) => (
          <SwitchRow
            {...props}
            bordered={false}
            checked={value}
            label={t('settings.organization.external_invoice.appearance.apply_color.switch_label.header')}
            onChange={(event) => {
              onChange(event)
              trackInvoicingSettings('Color applied to Document header', { checked: event.target.checked })
            }}
          />
        )}
      />
    </>
  )
}
